<template>
  <!-- 名片信息-组件 -->
  <div
    v-if="visible"
    @click.stop.self
    style="position: fixed; margin: auto; width: 290px; border-radius: 2px; background-color: #ffffff; box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);"
    :style="{height:CurrentHeight,top:currentTop,left:currentLeft}">
      <div style="height:100%;">
          <p style="border-bottom:1px solid #eaeaea;text-align:left;height:45px;line-height:45px;font-weight: 800;margin-left: 10px">个人信息</p>
          <div v-if="informationData.account.length==32">
            <p style="height: 30px;line-height: 30px;padding-left: 15px;" v-if="informationData.nickInTeam"><span>群昵称：</span><span>{{informationData.nickInTeam}}</span></p>
            <p style="height: 30px;line-height: 30px;padding-left: 15px;"><span>昵称：</span><span>{{informationData.nick}}</span></p>
            <p style="height: 30px;line-height: 30px;padding-left: 15px;"><span>手机号：</span><span>{{informationData.tel}}</span></p>
          </div>
          <div v-else>
            <p style="height: 30px;line-height: 30px;padding-left: 15px;" v-if="informationData.nickInTeam"><span>群昵称：</span><span>{{informationData.nickInTeam}}</span></p>
            <p style="height: 30px;line-height: 30px;padding-left: 15px;"><span>姓名：</span><span>{{informationData.nick}}</span></p>
            <p style="height: 30px;line-height: 30px;padding-left: 15px;"><span>岗位：</span><span>{{custom.role}}</span></p>
            <p style="height: 30px;line-height: 30px;padding-left: 15px;"><span>网点名称：</span><span>{{custom.stationName}}</span></p>
          </div>
          <div v-if="informationData.scene=='team'&&!isRobot" style="text-align:center;margin-top: 10px;">
            <button type="button" class="button" style="width: 150px; border-radius: 25px;background:#653EB3;color:#ffffff;" @click="itemClickEvent(informationData)">发消息</button>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      def_config: {
        title: '',
        // alert || confirm
        type: 'alert',
        message: '',
        cancel_text: '取消',
        done_text: '确定',
        done: function () { },
        cancel: function () { },
      },
      config: {
        title: null,
        type: null,
        message: null,
        cancel_text: null,
        done_text: null,
        done: null,
        cancel: null,
        link:'发消息'
      },
      informationData:{},
      visible: false,
      CurrentHeight:'150px',
      currentTop:'',
      currentLeft:'',
      custom:{},
      isRobot:false,
    }
  },
  methods: {
    open: function (config) {
      // 动态弹框高度
      console.log("config",config);
      if(window.im_group_fn.myInforomation){
        if(window.im_group_fn.myInforomation.account && window.im_group_fn.myInforomation.account == config.account){
          this.currentLeft = config.xClient - 290 + 'px';
        }else{
          this.currentLeft = config.xClient + 'px';
        }
      }
      this.informationData = config;
      this.isRobot = config.custom?(typeof config.custom=='string')?JSON.parse(config.custom).isRobot:config.custom.isRobot:false;
      this.currentTop = config.yClient + 'px';
      if(config.account.length == 32){
        if(config.scene == 'team'&&!this.isRobot){
          if(config.nickInTeam){
            this.CurrentHeight = '180px';
          }else{
            this.CurrentHeight = '150px';
          }
          
        }else{
          this.CurrentHeight = '130px';
        }
      }else{
        if(config.scene == 'team'&&!this.isRobot){
          if(config.nickInTeam){
            this.CurrentHeight = '210px';
          }else{
            this.CurrentHeight = '180px';
          }
        }else{
          this.CurrentHeight = '150px';
        }
        if(config.custom){
          this.custom = JSON.parse(config.custom);
        }
      }
      if (this.visible || !config) return;
      Object.assign(this.config, this.def_config, config);
      this.visible = true;
    },
    cancel: function () {
      if (this.config.cancel) this.config.cancel();
      this.close();
    },
    done: function () {
      if (this.config.done) this.config.done();
      this.close();
    },
    close: function () {
      this.visible = false;
      Object.assign(this.config, this.def_config);
    },
    itemClickEvent: function (item) {
      var sessionObj = {};
      if(item.account === 32){
        sessionObj.logInId = item.account;
      }else{
        sessionObj.userCode = item.account;
      }
      this.close();
      this.$emit('createSession', sessionObj);
      this.bus.$emit('closeConfigToInfo', 'close');
    }
  }
}
</script>
